import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type ContactsState = CommonTableState;

const initialState: ContactsState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            created: false,
            modified: false,
        },
        columnOrder: ["type", "primary", "contactValue", "user", "created", "modified", "mrt-row-actions"],
        density: "compact",
    },
};

export const contactSlice = createSlice({
    name: "contact",
    initialState: initialState,
    reducers: {
        updateContactTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateContactTableState } = contactSlice.actions;

export default contactSlice.reducer;
